module.exports = __webpack_public_path__ + "img/sect4-1.855ce504.png";